import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 54px 28px;
        gap: 32px;
    `,

    "RecordList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
    "RecordElement": styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding-bottom: 16px;
        border-bottom: 1px solid ${({ theme }) => theme.color["grey2"]};

        & > h2 {
            ${({ theme }) => theme.font["large-semibold"]};
            margin-bottom: 4px;
        }

        & > h3 {
            ${({ theme }) => theme.font["small-regular"]};
            white-space: nowrap;
            color: ${({ theme }) => theme.color["grey3"]};
        }

        & > p {
            ${({ theme }) => theme.font["small-regular"]};
            white-space: nowrap;

            & > span {
                ${({ theme }) => theme.font["small-semibold"]};
                color: ${({ theme }) => theme.color["red"]};
            }
        }

        & > div {
            margin-top: 8px;
        }
    `,

    "Option": styled.p`
        ${({ theme }) => theme.font["xsmall-medium"]};
    `,
}